module.exports = __webpack_public_path__ + "img/12.5c5d489e.png";